<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? 'Edit' : 'New'} Category` }}
            </h4>
            <v-form ref="categoryForm" @submit.prevent="save()" lazy-validation>
              <v-text-field
                v-model="categoryModel.name"
                label="Name"
                required
                outlined
                :rules="[v => !!v || 'Name is required']"
              ></v-text-field>
              <base-category-picker
                v-if="category || !isEdit"
                :chosen-category.sync="categoryModel.parent"
                :initial="categoryModel.parent"
                label="Parent Category"
                required
                outlined
              />
              <v-text-field
                min="0"
                v-model.number="categoryModel.priority"
                type="number"
                label="Priority"
                required
                outlined
              ></v-text-field>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Category } from '@/models/Category';
import { gql } from 'apollo-boost';
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      categoryModel: new Category(),
      me: '',
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: 'Categories',
          disabled: false,
          href: '/admin/categories',
        },
        {
          text: 'Category Detail',
          disabled: false,
          href: `/admin/category/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? 'Edit' : 'New'} Category`,
          disabled: true,
        },
      ];
    },
  },
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    category: {
      query: gql`
        query Category($id: ID!) {
          category(id: $id) {
            id
            name
            parent
            priority
            createdBy
          }
        }
      `,
      fetchPolicy: 'network-only',
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        console.log('fetched category');
        this.isLoading = false;
        this.categoryModel.id = this.category.id;
        this.categoryModel.name = this.category.name;
        this.categoryModel.parent = this.category.parent;
        this.categoryModel.priority = parseInt(this.category.priority) || 0;
        this.categoryModel.createdBy = this.category.createdBy;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.categoryForm.validate()) {
        self.$swal('Error', 'Validation failed', 'error');
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateCategory()
          .then(() => {
            this.$swal('Success!', 'Category was updated', 'success');
          })
          .catch(e => {
            console.log(e);
            this.$swal(
              'Error!',
              'something went wrong when trying to update the category, check data and try again later!',
              'error'
            );
          });
      } else {
        // create
        await this.createCategory()
          .then(() => {
            this.$swal('Success!', 'Category was created', 'success');
            // window.location.href = `/admin/category/${self.categoryModel.id}/edit`;
          })
          .catch(e => {
            console.log(e);
            this.$swal(
              'Error!',
              `Something went wrong when creating the category, check data and try again later!`,
              'error'
            );
          });
      }
      this.isLoading = false;
    },
    async updateCategory() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($category: CategoryUpdateInput!) {
              updateCategory(category: $category) {
                id
                updated
              }
            }
          `,
          variables: {
            category: {
              id: self.categoryModel.id,
              name: self.categoryModel.name,
              parent: self.categoryModel.parent,
              priority: parseInt(self.categoryModel.priority) || 0,
            },
          },
        });
        if (!response) {
          throw 'Something went wrong when creating the category!';
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createCategory() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createCategory($category: CategoryCreateInput!) {
              createCategory(category: $category) {
                id
              }
            }
          `,
          variables: {
            category: {
              name: self.categoryModel.name,
              parent: self.categoryModel.parent,
              priority: parseInt(self.categoryModel.priority) || 0,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw 'Something went wrong when creating the category!';
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createCategory) {
          self.categoryModel.id = response?.data?.createCategory?.id;
        }
      } catch (e) {
        console.log(e);
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
